import { Box, BoxProps } from '@chakra-ui/react';
import {
  faBinoculars,
  faBriefcaseMedical,
  faCalendar,
  faCamera,
  faCampground,
  faCircleCheck,
  faCoffee,
  faCookieBite,
  faGear,
  faList,
  faLocationPin,
  faMapLocationDot,
  faMountain,
  faMusic,
  faPersonBiking,
  faPersonHiking,
  faPersonRunning,
  faPersonSkating,
  faPersonSkiing,
  faPersonSkiingNordic,
  faPersonSnowboarding,
  faPersonSwimming,
  faPlaneDeparture,
  faSailboat,
  faShip,
  faSnowflake,
  faVest,
  faVestPatches,
  faWater
} from '@fortawesome/free-solid-svg-icons';
import {
  faBeerMug,
  faBoot,
  faCrutches,
  faDeer,
  faFishingRod,
  faMaskSnorkel,
  faPersonBikingMountain,
  faPersonSkiLift,
  faPersonToPortal,
  faPotFood,
  faShirtRunning,
  faSunglasses,
  faWatchFitness
} from '@fortawesome/pro-solid-svg-icons';
import React from 'react';

export const VerticalEllipsisIcon: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box as="svg" width="4" height="16" viewBox="0 0 4 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="2" cy="2" r="2" fill={props.fill || '#868F98'} fillOpacity="0.75" />
    <circle cx="2" cy="8" r="2" fill={props.fill || '#868F98'} fillOpacity="0.75" />
    <circle cx="2" cy="14" r="2" fill={props.fill || '#868F98'} fillOpacity="0.75" />
  </Box>
);

export const FacebookLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
  </Box>
);

export const InstagramLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="64 64 896 896"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 01-47.9 47.9z" />
  </Box>
);

export const LinkedinLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
  </Box>
);

export const PinterestLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z" />
  </Box>
);

export const RedditLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z" />
  </Box>
);

export const SpotifyLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z" />
  </Box>
);

export const TikTokLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
  </Box>
);

export const TumblrLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z" />
  </Box>
);

export const TwitterLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
  </Box>
);

export const VimeoLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z" />
  </Box>
);

export const YouTubeLogo: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box
    as="svg"
    width="16px"
    height="16x"
    viewBox="0 0 448 512"
    xmlns="http://www.w3.org/2000/svg"
    cursor="pointer"
    {...props}
  >
    <path d="M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z" />
  </Box>
);

export const LeftChevron: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box as="svg" width="6" height="8" viewBox="0 0 6 8" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 3.99788C0.00310529 3.86476 0.0326055 3.74296 0.0885007 3.6325C0.144396 3.51921 0.232897 3.40733 0.354003 3.29687L3.78224 0.23367C3.95303 0.0778899 4.16419 0 4.41572 0C4.5803 0 4.73246 0.0382369 4.8722 0.114711C5.01194 0.188352 5.12373 0.288901 5.20757 0.416357C5.29141 0.540981 5.33333 0.67835 5.33333 0.828465C5.33333 1.06355 5.23241 1.2689 5.03057 1.4445L2.13333 3.99363L5.03057 6.55125C5.23241 6.73252 5.33333 6.93787 5.33333 7.16729C5.33333 7.32023 5.29141 7.45902 5.20757 7.58364C5.12373 7.70827 5.01194 7.80882 4.8722 7.88529C4.73246 7.96176 4.5803 8 4.41572 8C4.16419 8 3.95303 7.92069 3.78224 7.76208L0.354003 4.69889C0.229791 4.58842 0.139738 4.47796 0.0838428 4.3675C0.0279476 4.2542 0 4.131 0 3.99788Z"
      fill={props.fill || '#555555'}
    />
  </Box>
);

export const RightChevron: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box as="svg" width="6" height="8" viewBox="0 0 6 8" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.00008 3.99788C5.99698 3.86475 5.96748 3.74296 5.91158 3.6325C5.85569 3.51921 5.76718 3.40733 5.64608 3.29687L2.21784 0.23367C2.04705 0.0778899 1.83589 0 1.58436 0C1.41978 0 1.26762 0.0382369 1.12788 0.114711C0.988145 0.188352 0.876355 0.288901 0.792512 0.416357C0.708669 0.540981 0.666748 0.67835 0.666748 0.828465C0.666748 1.06355 0.76767 1.2689 0.969514 1.4445L3.86675 3.99363L0.969514 6.55125C0.76767 6.73252 0.666748 6.93787 0.666748 7.16729C0.666748 7.32023 0.708669 7.45902 0.792512 7.58364C0.876355 7.70827 0.988145 7.80882 1.12788 7.88529C1.26762 7.96176 1.41978 8 1.58436 8C1.83589 8 2.04705 7.92069 2.21784 7.76208L5.64608 4.69888C5.77029 4.58842 5.86034 4.47796 5.91624 4.3675C5.97213 4.2542 6.00008 4.131 6.00008 3.99788Z"
      fill={props.fill || '#555555'}
    />
  </Box>
);

export const TransparentSpeechBubble: React.FC<BoxProps & { fill: string; stroke?: string }> = (props) => (
  <Box as="svg" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.2"
      d="M4.71357 2.37767C5.71836 1.77582 6.86759 1.45776 8.03886 1.4574C9.01335 1.45682 9.9754 1.67621 10.8533 2.0992C11.7312 2.5222 12.5023 3.13789 13.1091 3.90038C13.7159 4.66288 14.1429 5.55251 14.358 6.50295C14.5732 7.4534 14.5711 8.44015 14.3518 9.38965C14.1325 10.3392 13.7017 11.2269 13.0915 11.9867C12.4814 12.7466 11.7076 13.3589 10.8278 13.7781C9.9481 14.1973 8.9851 14.4124 8.01062 14.4075C7.19728 14.4036 6.39347 14.2464 5.6408 13.9457L2.10165 14.535C1.70622 14.6009 1.383 14.2219 1.51035 13.8419L2.41573 11.1396C1.91141 10.255 1.62174 9.26196 1.57307 8.2407C1.51734 7.07078 1.77997 5.90763 2.33301 4.87515C2.88604 3.84268 3.70877 2.97954 4.71357 2.37767Z"
      fill={props?.fill || 'white'}
    />
    <path
      d="M4.71357 2.37767C5.71836 1.77582 6.86759 1.45776 8.03886 1.4574C9.01335 1.45682 9.9754 1.67621 10.8533 2.0992C11.7312 2.5222 12.5023 3.13789 13.1091 3.90038C13.7159 4.66288 14.1429 5.55251 14.358 6.50295C14.5732 7.4534 14.5711 8.44015 14.3518 9.38965C14.1325 10.3392 13.7017 11.2269 13.0915 11.9867C12.4814 12.7466 11.7076 13.3589 10.8278 13.7781C9.9481 14.1973 8.9851 14.4124 8.01062 14.4075C7.19728 14.4036 6.39347 14.2464 5.6408 13.9457L2.10165 14.535C1.70622 14.6009 1.383 14.2219 1.51035 13.8419L2.41573 11.1396C1.91141 10.255 1.62174 9.26196 1.57307 8.2407C1.51734 7.07078 1.77997 5.90763 2.33301 4.87515C2.88604 3.84268 3.70877 2.97954 4.71357 2.37767Z"
      stroke={props?.stroke || 'white'}
      strokeWidth="1.5946"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.09424 8.58862C5.50845 8.58862 5.84424 8.25284 5.84424 7.83862C5.84424 7.42441 5.50845 7.08862 5.09424 7.08862C4.68002 7.08862 4.34424 7.42441 4.34424 7.83862C4.34424 8.25284 4.68002 8.58862 5.09424 8.58862Z"
      fill={props?.stroke || 'white'}
    />
    <path
      d="M8.19775 8.58862C8.61197 8.58862 8.94775 8.25284 8.94775 7.83862C8.94775 7.42441 8.61197 7.08862 8.19775 7.08862C7.78354 7.08862 7.44775 7.42441 7.44775 7.83862C7.44775 8.25284 7.78354 8.58862 8.19775 8.58862Z"
      fill={props?.stroke || 'white'}
    />
    <path
      d="M11.3013 8.58862C11.7155 8.58862 12.0513 8.25284 12.0513 7.83862C12.0513 7.42441 11.7155 7.08862 11.3013 7.08862C10.8871 7.08862 10.5513 7.42441 10.5513 7.83862C10.5513 8.25284 10.8871 8.58862 11.3013 8.58862Z"
      fill={props?.stroke || 'white'}
    />
  </Box>
);

export const Vetted: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box as="svg" width="11" height="14" viewBox="0 0 11 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.55209 13.3334C5.60509 13.3334 5.67134 13.3225 5.75084 13.3006C5.83476 13.2787 5.91648 13.2459 5.99598 13.2022C6.90143 12.7209 7.66554 12.2877 8.28832 11.9027C8.91109 11.5176 9.4124 11.1414 9.79225 10.7738C10.1721 10.4063 10.4482 10.0103 10.6204 9.58592C10.7927 9.15713 10.8788 8.66053 10.8788 8.09611V3.42322C10.8788 3.03382 10.8015 2.74942 10.6469 2.57003C10.4967 2.38626 10.256 2.22438 9.92476 2.08436C9.75692 2.01436 9.50516 1.9181 9.16948 1.79559C8.8338 1.67308 8.47162 1.54401 8.08293 1.40837C7.69867 1.27274 7.3387 1.14804 7.00302 1.03428C6.66734 0.920519 6.41779 0.837387 6.25436 0.784883C6.14394 0.745505 6.0269 0.717065 5.90322 0.699563C5.77955 0.677686 5.66251 0.666748 5.55209 0.666748C5.43283 0.666748 5.31137 0.679874 5.1877 0.706126C5.06403 0.728003 4.94919 0.754255 4.84318 0.784883C4.67534 0.828636 4.42358 0.907393 4.0879 1.02115C3.75664 1.13491 3.39667 1.2618 3.00799 1.40181C2.62372 1.53744 2.26375 1.66871 1.92807 1.79559C1.59239 1.9181 1.33842 2.01436 1.16616 2.08436C0.839319 2.22438 0.598601 2.38626 0.444012 2.57003C0.289422 2.74942 0.212128 3.03382 0.212128 3.42322V8.09611C0.212128 8.66053 0.298256 9.15495 0.470513 9.57936C0.642769 10.0038 0.918822 10.3997 1.29867 10.7673C1.68294 11.1348 2.18645 11.5111 2.80923 11.8961C3.432 12.2811 4.19391 12.7165 5.09494 13.2022C5.17886 13.2459 5.26057 13.2787 5.34008 13.3006C5.41958 13.3225 5.49025 13.3334 5.55209 13.3334ZM5.55209 11.9486C5.5035 11.9486 5.45492 11.9399 5.40633 11.9224C5.35774 11.9049 5.28708 11.8677 5.19432 11.8108C4.48321 11.382 3.88694 11.0167 3.4055 10.7148C2.92848 10.4085 2.54864 10.1219 2.26596 9.855C1.98328 9.58811 1.78011 9.30152 1.65643 8.99525C1.53276 8.68459 1.47093 8.30613 1.47093 7.85984V3.62012C1.47093 3.51073 1.48639 3.42979 1.5173 3.37728C1.54822 3.3204 1.60785 3.27446 1.69619 3.23946C1.87728 3.16508 2.08708 3.08413 2.32559 2.99663C2.56851 2.90912 2.82248 2.81943 3.08749 2.72754C3.35692 2.63566 3.62193 2.54378 3.88252 2.45189C4.14311 2.36001 4.38604 2.27469 4.6113 2.19594C4.83656 2.11718 5.02869 2.04717 5.1877 1.98592C5.2672 1.95529 5.33345 1.9356 5.38645 1.92685C5.44387 1.91373 5.49908 1.90716 5.55209 1.90716C5.59625 1.90716 5.64705 1.91373 5.70447 1.92685C5.76189 1.9356 5.83035 1.95529 5.90985 1.98592C6.06886 2.04717 6.25878 2.11937 6.47962 2.2025C6.70488 2.28563 6.94781 2.37314 7.2084 2.46502C7.46899 2.5569 7.7318 2.65097 7.99681 2.74723C8.26182 2.83911 8.51358 2.92881 8.75209 3.01632C8.99501 3.09945 9.20923 3.17383 9.39474 3.23946C9.48749 3.27009 9.54712 3.31384 9.57362 3.37072C9.60454 3.4276 9.61999 3.51073 9.61999 3.62012V7.85984C9.61999 8.30613 9.55595 8.68897 9.42786 9.00837C9.30419 9.3234 9.09881 9.61436 8.81171 9.88126C8.52462 10.1482 8.14256 10.4326 7.66554 10.7345C7.18852 11.032 6.59888 11.3908 5.8966 11.8108C5.80826 11.8677 5.73759 11.9049 5.68459 11.9224C5.63601 11.9399 5.59184 11.9486 5.55209 11.9486ZM4.88293 9.61217C5.12144 9.61217 5.31137 9.50279 5.45271 9.28402L8.22869 5.00492C8.27286 4.93491 8.3104 4.86491 8.34132 4.7949C8.37224 4.72052 8.3877 4.64614 8.3877 4.57176C8.3877 4.41424 8.32586 4.28517 8.20219 4.18454C8.08293 4.0839 7.94601 4.03359 7.79142 4.03359C7.58825 4.03359 7.4182 4.14297 7.28128 4.36174L4.85643 8.20768L3.72351 6.79006C3.64843 6.69381 3.57113 6.62599 3.49163 6.58661C3.41213 6.54723 3.32379 6.52754 3.22662 6.52754C3.0632 6.52754 2.92628 6.58442 2.81585 6.69818C2.70543 6.80757 2.65022 6.9432 2.65022 7.10509C2.65022 7.24948 2.70764 7.39386 2.82248 7.53825L4.28004 9.29058C4.36837 9.39997 4.45892 9.48091 4.55167 9.53341C4.64884 9.58592 4.75926 9.61217 4.88293 9.61217Z"
      fill={props?.fill || '#892BDD'}
    />
  </Box>
);

export const CloseIcon: React.FC<BoxProps & { fill: string }> = (props) => (
  <Box as="svg" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.363302 15.6366C0.526951 15.8003 0.716784 15.9083 0.932801 15.9607C1.15536 16.0131 1.37465 16.0131 1.59067 15.9607C1.80669 15.9083 1.99325 15.8036 2.15035 15.6464L8.00245 9.79251L13.8546 15.6464C14.0117 15.8036 14.1982 15.9083 14.4142 15.9607C14.6303 16.0131 14.8463 16.0131 15.0623 15.9607C15.2783 15.9083 15.4681 15.8003 15.6318 15.6366C15.7954 15.4729 15.9034 15.283 15.9558 15.0669C16.0082 14.8508 16.0082 14.6347 15.9558 14.4187C15.9034 14.2026 15.7987 14.016 15.6416 13.8588L9.79932 7.99509L15.6416 2.14119C15.7987 1.98404 15.9034 1.79742 15.9558 1.58134C16.0147 1.36525 16.0147 1.14917 15.9558 0.933088C15.9034 0.717004 15.7954 0.530387 15.6318 0.373235C15.4681 0.202988 15.2783 0.0916718 15.0623 0.0392879C14.8463 -0.013096 14.6303 -0.013096 14.4142 0.0392879C14.1982 0.0916718 14.0117 0.19644 13.8546 0.353591L8.00245 6.20749L2.15035 0.353591C1.99325 0.19644 1.80342 0.0916718 1.58085 0.0392879C1.36484 -0.013096 1.14555 -0.013096 0.922983 0.0392879C0.706965 0.0916718 0.520405 0.199714 0.363302 0.363413C0.199652 0.527113 0.0916437 0.717004 0.0392759 0.933088C-0.00654597 1.14917 -0.00654597 1.36853 0.0392759 1.59116C0.0916437 1.80724 0.196379 1.99059 0.353483 2.14119L6.20558 7.99509L0.353483 13.8588C0.196379 14.016 0.0916437 14.2026 0.0392759 14.4187C-0.0130919 14.6347 -0.0130919 14.8508 0.0392759 15.0669C0.0916437 15.283 0.199652 15.4729 0.363302 15.6366Z"
      fill={props?.fill || 'white'}
      fillOpacity="0.75"
    />
  </Box>
);

//all fa icons

export const FA_ICONS = {
  coffee: faCoffee,
  snowflake: faSnowflake,
  'briefcase-medical': faBriefcaseMedical,
  'person-skiing': faPersonSkiing,
  'person-skiing-nordic': faPersonSkiingNordic,
  'person-snowboarding': faPersonSnowboarding,
  mountain: faMountain,
  water: faWater,
  ship: faShip,
  'person-swimming': faPersonSwimming,
  sailboat: faSailboat,
  'person-to-portal': faPersonToPortal,
  'mask-snorkel': faMaskSnorkel,
  sunglasses: faSunglasses,
  'vest-patches': faVestPatches,
  deer: faDeer,
  'person-biking': faPersonBiking,
  'person-biking-mountain': faPersonBikingMountain,
  'person-running': faPersonRunning,
  'shirt-running': faShirtRunning,
  'pot-food': faPotFood,
  'watch-fitness': faWatchFitness,
  camera: faCamera,
  'fishing-rod': faFishingRod,
  'person-hiking': faPersonHiking,
  binoculars: faBinoculars,
  campground: faCampground,
  crutches: faCrutches,
  boot: faBoot,
  vest: faVest,
  'person-skating': faPersonSkating,
  list: faList,
  'circle-check': faCircleCheck,
  'location-pin': faLocationPin,
  'person-ski-lift': faPersonSkiLift,
  'beer-mug': faBeerMug,
  gear: faGear,
  'map-location-dot': faMapLocationDot,
  'plane-departure': faPlaneDeparture,
  'cookie-bite': faCookieBite,
  calendar: faCalendar,
  music: faMusic
};
